import React, { useEffect } from 'react';
import { createContext } from 'react';
import { useTranslation } from 'react-i18next';

export const LocaleContext = createContext<null>(null);
export const rtlLangs = ['ar', 'he'];
export const LocaleContextProvider = ({ children }: { children: React.ReactNode }) => {
  const { i18n } = useTranslation();
  const { language } = i18n;

  useEffect(() => {
    document.querySelector('html')?.setAttribute('lang', language);
  }, [language]);

  return <LocaleContext.Provider value={null}>{children}</LocaleContext.Provider>;
};
